import styled from 'styled-components';

export const WizardStepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StepsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;  
`;